module.exports = __webpack_public_path__ + "img/comment.88a67fd9.svg";